import React from 'react';
import Container from '../../../primitives/grid/container';
import NotchedSlider from '../../../primitives/notched-slider';
import { breakpoints } from '../../../primitives/tokens';
import Typography from '../../../primitives/typography';
import Pagination from '../../../primitives/notched-slider/pagination';

export interface FranchiseReviewsSlide {
    name: string
    review: string
    city?: string
    state?: string
    zip?: string
    category?: string
}
interface FranchiseReviewsSliderProps {
    slides?: FranchiseReviewsSlide[]
    city?: string
}

// TODO: Find a better location for this to live

const FranchiseReviewsSlider = (data: FranchiseReviewsSliderProps): JSX.Element | null => {
    if (!data) {
        return null;
    }
    const { slides, city } = data;

    if (!slides || slides.length < 1) {
        return null;
    }

    const slidesPerViewDesktop = 3;

    return (
        <NotchedSlider>
            <div css={{
                padding: '48px 0',
            }}
            >
                <Container css={{ position: 'relative' }}>
                    <Typography
                        as="h2"
                        fontSize={{
                            dt: '3xl',
                            tb: '2xl',
                            mb: '2xl',
                        }}
                        fontWeight="regular"
                        css={{
                            margin: 'auto',
                            paddingBottom: '24px',
                            lineHeight: 1.25,
                            textAlign: 'center',
                            textTransform: 'capitalize',
                            [breakpoints.mb]: {
                                paddingBottom: '16px',
                            },
                        }}
                    >
                        What our
                        {' '}
                        {city}
                        <br />
                        {' '}
                        customers are saying
                    </Typography>

                    <div css={{
                        [breakpoints.tb]: {
                            display: 'none',
                        },
                    }}
                    >
                        {slides.length > slidesPerViewDesktop
                            ? (
                                <NotchedSlider.Slides slidesPerView={slidesPerViewDesktop}>
                                    {slides.map((slide) => {
                                        const { name, review, city } = slide;

                                        return (
                                            <div
                                                key={name}
                                                css={{
                                                    display: 'flex',
                                                    flexDirection: 'row',
                                                    justifyContent: 'space-around',
                                                    maxWidth: '100%',
                                                    paddingLeft: '24px',
                                                    paddingRight: '24px',
                                                    paddingBottom: '18px',
                                                    paddingTop: '24px',
                                                    [breakpoints.mb]: {
                                                        flexDirection: 'column',
                                                        paddingLeft: '8px',
                                                        paddingRight: '8px',
                                                        paddingTop: '24px',
                                                    },
                                                }}
                                            >
                                                <div css={{
                                                    width: '100%',
                                                }}
                                                >
                                                    <Typography
                                                        fontSize={{
                                                            dt: 'lg',
                                                            tb: 'base',
                                                        }}
                                                        color="primaryOrange"
                                                        css={{
                                                            paddingBottom: '20px',
                                                            [breakpoints.mb]: {
                                                                marginBottom: '40px',
                                                            },
                                                        }}
                                                        dangerouslySetInnerHTML={{
                                                            __html: review,
                                                        }}
                                                    />
                                                    <Typography fontSize="sm" fontWeight="medium">{name}</Typography>
                                                    <Typography
                                                        fontSize="sm"
                                                        fontWeight="medium"
                                                        css={{
                                                            marginBottom: '32px',
                                                            [breakpoints.tb]: {
                                                                marginBottom: '0',
                                                            },
                                                        }}
                                                    >
                                                        {city}
                                                    </Typography>
                                                </div>
                                            </div>
                                        );
                                    })}
                                </NotchedSlider.Slides>
                            )
                            : (
                                <div css={{ display: 'flex', justifyContent: 'center' }}>

                                    {slides.map((slide) => {
                                        const { name, review, city } = slide;

                                        return (
                                            <div
                                                key={name}
                                                css={{
                                                    display: 'flex',
                                                    flexDirection: 'row',
                                                    justifyContent: 'space-around',
                                                    maxWidth: '100%',
                                                    paddingLeft: '24px',
                                                    paddingRight: '24px',
                                                    paddingBottom: '18px',
                                                    paddingTop: '24px',
                                                    flexBasis: `${100 / slides.length}%`,
                                                    [breakpoints.mb]: {
                                                        flexDirection: 'column',
                                                        paddingLeft: '8px',
                                                        paddingRight: '8px',
                                                        paddingTop: '24px',
                                                    },
                                                }}
                                            >
                                                <div css={{
                                                    width: '100%',
                                                }}
                                                >
                                                    <Typography
                                                        fontSize={{
                                                            dt: 'lg',
                                                            tb: 'base',
                                                        }}
                                                        color="primaryOrange"
                                                        css={{
                                                            paddingBottom: '20px',
                                                            [breakpoints.mb]: {
                                                                marginBottom: '40px',
                                                            },
                                                        }}
                                                        dangerouslySetInnerHTML={{
                                                            __html: review,
                                                        }}
                                                    />
                                                    <Typography fontSize="sm" fontWeight="medium">{name}</Typography>
                                                    <Typography
                                                        fontSize="sm"
                                                        fontWeight="medium"
                                                        css={{
                                                            marginBottom: '32px',
                                                            [breakpoints.tb]: {
                                                                marginBottom: '0',
                                                            },
                                                        }}
                                                    >
                                                        {city}
                                                    </Typography>
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            )}
                        {slides.length > slidesPerViewDesktop && <Pagination slidesLength={slides.length} />}
                    </div>
                    <div css={{
                        display: 'none',
                        [breakpoints.tb]: {
                            display: 'block',
                        },
                    }}
                    >
                        {slides.length > 1
                            ? (
                                <NotchedSlider.Slides slidesPerView={1}>
                                    {slides.map((slide) => {
                                        const { name, review, city } = slide;

                                        return (
                                            <div
                                                key={name}
                                                css={{
                                                    display: 'flex',
                                                    flexDirection: 'row',
                                                    justifyContent: 'space-around',
                                                    maxWidth: '100%',
                                                    paddingLeft: '24px',
                                                    paddingRight: '24px',
                                                    paddingBottom: '18px',
                                                    paddingTop: '24px',
                                                    [breakpoints.mb]: {
                                                        flexDirection: 'column',
                                                        paddingLeft: '8px',
                                                        paddingRight: '8px',
                                                        paddingTop: '24px',
                                                    },
                                                }}
                                            >
                                                <div css={{
                                                    width: '100%',
                                                }}
                                                >
                                                    <Typography
                                                        fontSize={{
                                                            dt: 'lg',
                                                            tb: 'base',
                                                        }}
                                                        color="primaryOrange"
                                                        css={{
                                                            paddingBottom: '20px',
                                                            [breakpoints.mb]: {
                                                                marginBottom: '40px',
                                                            },
                                                        }}
                                                        dangerouslySetInnerHTML={{
                                                            __html: review,
                                                        }}
                                                    />
                                                    <Typography fontSize="sm" fontWeight="medium">{name}</Typography>
                                                    <Typography
                                                        fontSize="sm"
                                                        fontWeight="medium"
                                                        css={{
                                                            marginBottom: '32px',
                                                            [breakpoints.tb]: {
                                                                marginBottom: '0',
                                                            },
                                                        }}
                                                    >
                                                        {city}
                                                    </Typography>
                                                </div>
                                            </div>
                                        );
                                    })}
                                </NotchedSlider.Slides>
                            )
                            : (
                                <div>
                                    {slides.map((slide) => {
                                        const { name, review, city } = slide;

                                        return (
                                            <div
                                                key={name}
                                                css={{
                                                    display: 'flex',
                                                    flexDirection: 'row',
                                                    justifyContent: 'space-around',
                                                    maxWidth: '100%',
                                                    paddingLeft: '24px',
                                                    paddingRight: '24px',
                                                    paddingBottom: '18px',
                                                    paddingTop: '24px',
                                                    [breakpoints.mb]: {
                                                        flexDirection: 'column',
                                                        paddingLeft: '8px',
                                                        paddingRight: '8px',
                                                        paddingTop: '24px',
                                                    },
                                                }}
                                            >
                                                <div css={{
                                                    width: '100%',
                                                }}
                                                >
                                                    <Typography
                                                        fontSize={{
                                                            dt: 'lg',
                                                            tb: 'base',
                                                        }}
                                                        color="primaryOrange"
                                                        css={{
                                                            paddingBottom: '20px',
                                                            [breakpoints.mb]: {
                                                                marginBottom: '40px',
                                                            },
                                                        }}
                                                        dangerouslySetInnerHTML={{
                                                            __html: review,
                                                        }}
                                                    />
                                                    <Typography fontSize="sm" fontWeight="medium">{name}</Typography>
                                                    <Typography
                                                        fontSize="sm"
                                                        fontWeight="medium"
                                                        css={{
                                                            marginBottom: '32px',
                                                            [breakpoints.tb]: {
                                                                marginBottom: '0',
                                                            },
                                                        }}
                                                    >
                                                        {city}
                                                    </Typography>
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            )}
                        {slides.length > 1 && <Pagination slidesLength={slides.length} />}
                    </div>
                </Container>
            </div>
        </NotchedSlider>
    );
};

export default FranchiseReviewsSlider;
